import type { RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw[] = [
  {
    path: "/breakout/:lender/:lenderApplicationId",
    name: "iframeBreakout",
    component: () => import("@/views/external/IframeBreakoutView.vue"),
    meta: {
      public: true,
      hideStepper: true,
    },
  },
]

export default routes
